<template>
  <figure class="image-block">
    <div class="image-frame">
      <img
        :src="block.src"
        :alt="block.alt || ''"
        class="image-block-img"
        loading="lazy"
      />
    </div>
    <figcaption v-if="block.caption" class="image-block-caption">
      <q-icon name="image" size="12px" :style="{ color: 'var(--oa-gold-full)' }" />
      <span>{{ block.caption }}</span>
    </figcaption>
  </figure>
</template>

<script setup lang="ts">
interface ImageBlock {
  type: 'image';
  src: string;
  alt?: string;
  caption?: string;
}

defineProps<{ block: ImageBlock }>();
</script>

<style scoped lang="scss">
.image-block {
  margin: 28px 0;
  text-align: center;
}

.image-frame {
  display: inline-block;
  max-width: 100%;
  border-radius: var(--oa-radius-xl);
  overflow: hidden;
  background: var(--oa-bg-2);
  border: 1px solid color-mix(in srgb, var(--oa-border) 50%, transparent);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
}

.image-block-img {
  max-width: 100%;
  display: block;
  margin: 0 auto;
}

.image-block-caption {
  margin-top: 10px;
  font-size: var(--oa-text-xs);
  color: var(--oa-text-muted);
  font-style: italic;
  display: inline-flex;
  align-items: center;
  gap: 6px;
}
</style>
